import { render, staticRenderFns } from "./SearchTextField.vue?vue&type=template&id=4605fc38&scoped=true"
import script from "./SearchTextField.vue?vue&type=script&lang=ts"
export * from "./SearchTextField.vue?vue&type=script&lang=ts"
import style0 from "./SearchTextField.vue?vue&type=style&index=0&id=4605fc38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4605fc38",
  null
  
)

export default component.exports